<div class="flex items-center justify-between px-3 sm:px-4 py-2 sm:py-3 border-b border-slate-200">
  <h2 class="text-sm sm:text-base font-bold tracking-widest uppercase text-slate-800 m-0">
    Invoice Details - {{ data?.transactionNo }}
  </h2>
<button mat-icon-button (click)="onCancel()"
  class="text-slate-600 hover:text-rose-600 scale-100">
  <mat-icon fontSet="material-icons" class="font-bold">close</mat-icon>
</button>
</div>

<form #metadataForm="ngForm">
<mat-dialog-content class="mat-typography custom-scrollbar overflow-x-hidden">
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-2 sm:mt-3">
    <!-- Business Name -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Business Name</mat-label>
      <mat-select name="businessName" [(ngModel)]="metadata.businessName" placeholder="Select Business Name" required>
        <mat-option value="Riddhi Siddhi Services">Riddhi Siddhi Services</mat-option>
        <mat-option value="MB Cleaning Services">MB Cleaning Services</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Work Order No -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Work Order No</mat-label>
      <input matInput name="workOrderNo" [(ngModel)]="metadata.workOrderNo" placeholder="Enter Work Order No" required />
    </mat-form-field>

    <!-- Working Date -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Working Dates</mat-label>
      <input matInput name="workingDate" [(ngModel)]="metadata.workingDate" placeholder="Enter Working Dates" required />
    </mat-form-field>

    <!-- Worksite -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Worksite</mat-label>
      <input matInput name="worksite" [(ngModel)]="metadata.worksite" placeholder="Enter Worksite" required />
    </mat-form-field>

    <!-- To Customer Address -->
    <mat-form-field appearance="outline" class="w-full sm:col-span-2">
      <mat-label>To Customer Address</mat-label>
      <textarea matInput name="toCustomerAddress" rows="2" [(ngModel)]="metadata.toCustomerAddress" class="resize-none" required></textarea>
    </mat-form-field>

    <!-- Quotation T&C -->
    <!-- <mat-form-field appearance="outline" class="w-full sm:col-span-2">
      <mat-label>Quotation T&C</mat-label>
      <textarea matInput name="quotationTc" rows="2" [(ngModel)]="metadata.quotationTc" class="resize-none"></textarea>
    </mat-form-field> -->
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-col-reverse sm:flex-row sm:justify-end px-4 py-3 border-t border-slate-200 gap-3 sm:gap-2 box-border">
  <button type="button" (click)="onCancel()"
    class="w-full sm:w-auto px-3 py-2 rounded-md border border-slate-300 text-slate-600 text-xs font-bold tracking-widest uppercase hover:bg-slate-50 transition-colors">
    Cancel
  </button>
  <button type="button" (click)="onSubmit()" [disabled]="!metadataForm.valid"
    class="w-full sm:w-auto px-3 py-2 rounded-md bg-slate-900 text-white text-xs font-bold tracking-widest uppercase shadow-md hover:bg-slate-800 transition-colors disabled:bg-slate-300 disabled:text-slate-500 disabled:shadow-none disabled:cursor-not-allowed">
    Save & Print
  </button>
</mat-dialog-actions>
</form>
